import { SVG, IconProps } from "../SVG";
import React from "react";

export const MedicareM = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="#13126C"
            fillRule="evenodd"
            d="m5.432 20.446 1.79-10.386 3.433 10.386H13.4L16.88 10.06l1.756 10.386h3L18.88 4h-3l-3.834 11.47L8.266 4H5.221L2.398 20.446h3.034Z"
            clipRule="evenodd"
        />
    </SVG>
);
MedicareM.displayName = "MedicareM";
